export const ADD_PACKAGE_BOXES_SUCCESS = 'ADD_PACKAGE_BOXES_SUCCESS';
export const ADD_PACKAGE_BOXES_REQUEST = 'ADD_PACKAGE_BOXES_REQUEST';
export const ADD_PACKAGE_BOXES_FAILURE = 'ADD_PACKAGE_BOXES_FAILURE';
export const addPackageBoxesSuccess = (payload) => ({
    type: ADD_PACKAGE_BOXES_SUCCESS,
    payload,
});
export const addPackageBoxesRequest = (payload) => ({
    type: ADD_PACKAGE_BOXES_REQUEST,
    payload
});
export const addPackageBoxesFailure = (payload) => ({
    type: ADD_PACKAGE_BOXES_FAILURE,
    payload,
});
